const INTERVAL = 6000;

export function initFvSlider(): void {
  const section = document.querySelector<HTMLElement>('section.fv');
  if (!section) return;

  const items = Array.from(section.querySelectorAll<HTMLElement>(':scope > ul > li'));
  const total = items.length;
  if (total === 0) return;

  if (total === 1) {
    items[0].classList.add('is-active');
    const operator = section.querySelector<HTMLElement>('.operator');
    if (operator) operator.style.display = 'none';
    return;
  }

  const indicators = Array.from(section.querySelectorAll<HTMLElement>('.indicator > span'));
  const player   = section.querySelector<HTMLElement>('.player');
  const btnLeft  = section.querySelector<HTMLElement>('.left');
  const btnRight = section.querySelector<HTMLElement>('.right');

  let current     = 0;
  let timerId: ReturnType<typeof setInterval> | null = null;
  let isPlaying   = true;
  let isAnimating = false;

  function goTo(nextIndex: number, dir: 'next' | 'prev' = 'next'): void {
    if (isAnimating) return;
    isAnimating = true;

    const leaving = items[current];
    current = ((nextIndex % total) + total) % total;
    const entering = items[current];

    const leaveClass = dir === 'next' ? 'is-leaving-left' : 'is-leaving-right';
    const enterClass = dir === 'next' ? 'is-entering-right' : 'is-entering-left';

    leaving.classList.remove('is-active');
    leaving.classList.add(leaveClass);
    entering.classList.add(enterClass, 'is-active');

    leaving.addEventListener('animationend', () => {
      leaving.classList.remove(leaveClass);
      entering.classList.remove(enterClass);
      isAnimating = false;
    }, { once: true });

    indicators.forEach((s, i) => s.classList.toggle('js-current', i === current));
  }

  function startAuto(): void {
    timerId = setInterval(() => goTo(current + 1, 'next'), INTERVAL);
    isPlaying = true;
    player?.classList.remove('is-paused');
  }

  function stopAuto(): void {
    if (timerId !== null) clearInterval(timerId);
    timerId = null;
    isPlaying = false;
    player?.classList.add('is-paused');
  }

  function resetInterval(): void {
    if (timerId !== null) {
      clearInterval(timerId);
      timerId = setInterval(() => goTo(current + 1, 'next'), INTERVAL);
    }
  }

  items[0].classList.add('is-active');
  startAuto();

  player?.addEventListener('click', () => {
    if (isPlaying) stopAuto(); else startAuto();
  });

  btnLeft?.addEventListener('click', () => {
    goTo(current - 1, 'prev');
    resetInterval();
  });

  btnRight?.addEventListener('click', () => {
    goTo(current + 1, 'next');
    resetInterval();
  });

  indicators.forEach((span, i) => {
    span.addEventListener('click', () => {
      if (i === current) return;
      goTo(i, i > current ? 'next' : 'prev');
      resetInterval();
    });
  });

  // SP スワイプ操作（touch イベントのみ → PC には影響しない）
  const SWIPE_THRESHOLD = 50;
  let swipeStartX: number | null = null;
  let swipeStartY: number | null = null;

  section.addEventListener('touchstart', (e: TouchEvent) => {
    swipeStartX = e.touches[0].clientX;
    swipeStartY = e.touches[0].clientY;
  }, { passive: true });

  // 横スワイプ中はページスクロール・バウンスを抑制
  section.addEventListener('touchmove', (e: TouchEvent) => {
    if (swipeStartX === null || swipeStartY === null) return;
    const dx = Math.abs(e.touches[0].clientX - swipeStartX);
    const dy = Math.abs(e.touches[0].clientY - swipeStartY);
    if (dx > dy) e.preventDefault();
  }, { passive: false });

  section.addEventListener('touchend', (e: TouchEvent) => {
    if (swipeStartX === null) return;
    const delta = e.changedTouches[0].clientX - swipeStartX;
    swipeStartX = null;
    swipeStartY = null;
    if (Math.abs(delta) < SWIPE_THRESHOLD) return;
    if (delta < 0) {
      goTo(current + 1, 'next');
    } else {
      goTo(current - 1, 'prev');
    }
    resetInterval();
  }, { passive: true });

  section.addEventListener('touchcancel', () => {
    swipeStartX = null;
    swipeStartY = null;
  }, { passive: true });
}
